<template>
  <div class="menubar" v-if="!$store.state.menubarRouters.full&&!this.$route.query.hide">
    <el-scrollbar style="height:100%;">
        <!-- <h4>{{$t($store.state.menubarRouters.title)}}</h4> -->
        <!--{{$store.state.menubarRouters}}-->
          <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" ref="myMenu" :collapse="isCollapse" @open="open" :default-openeds="openeds" >
            <template v-for="(val,i) in $store.state.menubarRouters.children" v-if="!val.hide">
              <el-submenu :index="val.path+i.toString()" :key="val.path+i" v-if="val.children">
                <template slot="title">
                  <!-- <i :class="['iconfont','icon-reset',val.icon]"></i> -->
                  <img class="nav-icon no-ok" :src="require(`@/assets/newicons/${val.icon_img || 'nav01'}.png`)">
                  <img class="nav-icon yes-ok" :src="require(`@/assets/newicons/${val.icon_img || 'nav01'}_ok.png`)">
                  <span>{{$t(val.name)}}</span>
                </template>
                <template v-for="(child, n) in val.children" v-if="!child.hide">
                  <el-submenu :index="child.path+n.toString()" :key="child.path+n" v-if="child.children" class="submenu-padding">
                    <template slot="title">
                      <span>{{$t(child.name)}}</span>
                    </template>
                    <template v-for="(grondChild) in child.children" v-if="!grondChild.hide">
                      <router-link :to="$store.state.menubarRouters.path+'/'+val.path+'/'+child.path+'/'+grondChild.path" :key="grondChild.name">
                        <el-menu-item :index="$store.state.menubarRouters.path+'/'+val.path+'/'+child.path+'/'+grondChild.path"
                          :data-index="$store.state.menubarRouters.path+'/'+val.path+'/'+child.path+'/'+grondChild.path">
                          <!-- <span style="position: relative;">{{$t(grondChild.name)}} <img v-if="grondChild.meta.beta" src="@/assets/beta.svg" class="bata" alt=""></span> -->
                          <span style="position: relative;">{{$t(grondChild.name)}}</span>
                        </el-menu-item>
                      </router-link>
                    </template>
                  </el-submenu>
                  <router-link v-else :to="$store.state.menubarRouters.path+'/'+val.path+'/'+child.path" :key="child.name">
                    <el-menu-item :index="$store.state.menubarRouters.path+'/'+val.path+'/'+child.path" :data-index="$store.state.menubarRouters.path+'/'+val.path+'/'+child.path">
                      <span>{{$t(child.name)}}</span>
                    </el-menu-item>
                  </router-link>
                </template>
              </el-submenu>
              <el-menu-item @click="clickNext(val.path)" :class="isCollapse?'':'menu-item'"  :index="$store.state.menubarRouters.path + '/' +val.path" :key="i"
                :data-index="$store.state.menubarRouters.path + '/' +val.path" v-else>
                <!-- <i :class="['iconfont','icon-reset',val.icon]"></i> -->
                <img class="nav-icon no-ok" :src="require(`@/assets/newicons/${val.icon_img || ''}.png`)">
                <img class="nav-icon yes-ok" :src="require(`@/assets/newicons/${val.icon_img || 'nav01'}_ok.png`)">
                <span slot="title">{{$t(val.meta.title)}}</span>
              </el-menu-item>
            </template>
          </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'menubar',
  data () {
    return {
      openeds: ['talk1', 'search0', 'junbros1', 'inquiry2', 'talkManage2', 'talkManage3'],
      data: {},
      defaultActive: ''
    }
  },
  computed: {
    isCollapse () {
      return this.$store.state.user.isCollapse
    }
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler: function (to, from) {
        this.defaultActive = this.defaultActivePath()
        if (this.$route.meta && this.$route.meta.path) {
          return
        }
        this.$nextTick(() => {
          if (this.$refs.myMenu) {
            if (to.meta.highlight) {
              this.$refs.myMenu.activeIndex = to.meta.highlight
            } else {
              this.$refs.myMenu.activeIndex = to.path
            }
          }
        })
      }
    }
  },
  methods: {
    open (val) {
      console.log(val)
    },
    clickNext (path) {
      path = this.$store.state.menubarRouters.path + '/' + path
      this.$bus.$emit('left-menu-click', path)
      this.$router.push({ path })
    },
    defaultActivePath () {
      if (this.$route.meta) {
        return this.$route.meta.path || this.$route.path
      }
      return this.$route.path
    },
    select (val) { }
  },
  mounted () {
    // console.log(this.$store.state.menubarRouters)
  }
}
</script>

<style scoped lang="scss">
.bata{
  width:30px;
  height:19px;
  top: -10px;
  right: -33px;
  position: absolute;
}
.menubar .el-menu:not(.el-menu--collapse) {
   width: 192px;
}
.menubar {
  width: 192px;
  float: left;
  height: 100%;
  background-color: #fff;
  // .el-menu{
  //   box-shadow: 5px 5px 5px rgba(215, 215, 215, 0.35);
  // }
  // box-shadow: 5px 5px 5px rgba(215, 215, 215, 0.35);
  h4 {
    height: 50px;
    text-align: center;
    width: 100%;
    line-height: 50px;
    font-weight: normal;
    border-bottom: 1px solid #eee;
    font-size: 16px;
  }
  .el-menu {
    border-right: none;
  }
  .el-submenu.is-active /deep/ .el-submenu__title {
      background: rgba(80, 136, 255, 0.06);
      border-left: 3px solid #5088FF;
      .el-submenu__icon-arrow{
        color: #5088FF;
      }
      .yes-ok{
        display: inline;
      }
      .no-ok{
        display: none;
      }
  }
  .el-submenu /deep/ .el-submenu__title {
    height: 40px;
    line-height: 40px;
    border-left: 3px solid #ffffff;
    &:hover{
      background: rgba(80, 136, 255, 0.06);
      border-left: 3px solid #5088FF;
      .el-submenu__icon-arrow{
        color: #5088FF;
      }
      .yes-ok{
        display: inline;
      }
      .no-ok{
        display: none;
      }
    }
  }
  .submenu-padding{
    /deep/.el-submenu__title,/deep/.el-menu-item{
      padding-left: 46px !important;
    }
  }
}
.el-menu-item {
  transition: none;
  height: 40px;
  line-height: 40px;
  &:hover{
      .yes-ok{
        display: inline;
      }
      .no-ok{
        display: none;
      }
  }
}
.el-submenu .el-menu-item {
  min-width: initial;
  height: 40px;
  line-height: 40px;
  display: flex;
  align-items: center;
  padding-left: 24.5px !important;
  &::before{
    content: ' ';
    display: block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #DADCE5;
    margin-right: 16px;
  }
  &:hover{
    background: none;
    color: #5088FF;
    &::before{
      background: #5088FF;
    }
    span{
      color: #5088FF;
    }
  }
  &.is-active{
    background: none;
    border-left: 3px solid #ffffff;
    &::before{
      background: #5088FF;
    }
    span{
      color: #5088FF;
    }
  }
  span{
    font-size: 13px;
    color: #666666;
  }
}

/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
.icon-reset{
  // font-size: 20px;
  margin-right: 10px;
}
.menu-item:not(.el-menu--collapse) {
  // padding-left: 40px !important;
}
.menu-item{

}
.nav-icon{
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.yes-ok{
  display: none;
}

/deep/ {
  .el-submenu__title .el-submenu__icon-arrow{
    transform: rotateZ(270deg);
  }
  .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow{
        transform: rotateZ(0deg);
  }
  .el-menu-item{
    height: 40px;
    line-height: 40px;
    border-left: 3px solid #ffffff;
  }
  .el-menu-item.is-active{
    border-left: 3px solid #5088FF;
    border-right: none;
    .yes-ok{
      display: inline;
    }
    .no-ok{
      display: none;
    }
  }


}
</style>
